import {
  paths,
  settingsResponseSchema,
  type SettingsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 读当前已保存的配置。草稿只在页面里，读到的永远是生效中的那份。 */
export const getSettingsOperation = "settings.read";

export type GetSettingsOperation = typeof getSettingsOperation;

export type GetSettingsFailure = BackendFailure<GetSettingsOperation>;

export function getSettings(
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<SettingsResponse, GetSettingsFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getSettingsOperation,
    parse: (payload) => settingsResponseSchema.parse(payload),
    path: paths.settings,
    signal: options.signal,
  });
}
